var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 12 4 L 20 4 L 20 12 M 12 20 L 4 20 L 4 12",
    stroke: "currentColor",
    strokeWidth: 1.2
  })));
};

export default __webpack_public_path__ + "static/media/expand.221d7a97.svg";
export { SvgComponent as ReactComponent };